export const config = {
  API_URL: import.meta.env.REACT_APP_API_URL,
  OAUTH_CLIENT_KEY: import.meta.env.REACT_APP_OAUTH_CLIENT_KEY,
  OAUTH_CLIENT_ID: import.meta.env.REACT_APP_OAUTH_CLIENT_ID,
  OAUTH_SCOPE: import.meta.env.REACT_APP_OAUTH_SCOPE,
  FIREBASE_KEY: import.meta.env.REACT_APP_FIREBASE_KEY,
  FIREBASE_API_KEY: import.meta.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: import.meta.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: import.meta.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: import.meta.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: import.meta.env.REACT_APP_FIREBASE_APP_ID,
}
